import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ArrowRightIcon, ArrowUpIcon } from 'lucide-react';
interface CaseStudyNavigationProps {
  homePath: string;
  previousCase?: {
    category: string;
    title: string;
    slug: string;
  };
  nextCase?: {
    category: string;
    title: string;
    slug: string;
  };
}
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};
export function CaseStudyNavigation({
  homePath,
  previousCase,
  nextCase
}: CaseStudyNavigationProps) {
  return <section className="bg-white py-16 px-4 sm:px-6 md:px-8 pb-32 sm:pb-24" data-id="element-101">
      <div className="container mx-auto max-w-6xl" data-id="element-102">
        {/* Back to Top Button */}
        <div className="flex justify-center mb-12" data-id="element-103">
          <button onClick={scrollToTop} className="px-8 py-3 bg-white text-gray-900 font-medium border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors flex items-center gap-2" data-id="element-104">
            <ArrowUpIcon className="w-4 h-4" data-id="element-105" />
            Back to Top
          </button>
        </div>

        {/* Navigation Links */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-6 pt-8 border-t border-gray-200" data-id="element-106">
          {/* Previous - Left side */}
          {previousCase ? <Link to={`/case-study/${previousCase.slug}`} className="flex items-center text-gray-700 hover:text-black transition-colors group" data-id="element-107">
              <ArrowLeftIcon className="w-4 h-4 mr-2 transition-transform group-hover:-translate-x-1" data-id="element-108" />
              <span className="font-medium" data-id="element-109">
                {previousCase.category}: {previousCase.title}
              </span>
            </Link> : <div data-id="element-110"></div>}

          {/* Next - Right side */}
          {nextCase ? <Link to={`/case-study/${nextCase.slug}`} className="flex items-center text-gray-700 hover:text-black transition-colors group" data-id="element-111">
              <span className="font-medium" data-id="element-112">
                {nextCase.category}: {nextCase.title}
              </span>
              <ArrowRightIcon className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" data-id="element-113" />
            </Link> : <div data-id="element-114"></div>}
        </div>
      </div>
    </section>;
}